import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="w-full border-b border-background-200 bg-background-100">
      <ol className="mx-auto flex w-full max-w-[1280px] flex-wrap items-center gap-2 px-4 py-3 font-label text-xs text-secondary-600 md:px-6">
        {items.map((item, index) => (
          <li key={`${item.label}-${index}`} className="flex items-center gap-2">
            {item.to ? (
              <Link to={item.to} className="transition-colors hover:text-primary-600">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-800">{item.label}</span>
            )}
            {index < items.length - 1 && (
              <i className="ri-arrow-right-s-line text-secondary-400" aria-hidden="true"></i>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}